<ng-container
              *ngIf="{
  filteredDiners: diners$ | async
} as vm">
  <ion-header>
    <ion-toolbar mode="md" color="dark">
      <ion-title>
        <ng-container>Select Resident Account For Guest Billing</ng-container>
      </ion-title>
      <ion-buttons slot="end">
        <ion-button mode="md"
                    (click)="onCloseModal()">Close
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content fullscreen>
    <div>
      <div class="select-resident__filter">
        <ion-input placeholder="Search a Resident"
                   min="2"
                   minlength="2"
                   debounce="500"
                   clearInput="true"
                   [value]="searchQuery"
                   (ionChange)="searchingDiners($event)"></ion-input>
        <small class="ion-text-start">A minimum of 3 characters are required to search.</small>
      </div>
      <ion-list
                class="select-resident__list"
                *ngIf="!isSearchingDiner && vm.filteredDiners as diners">
        <ng-container *ngFor="let diner of diners; index as index">
          <ion-item
                    class="select-resident__resident">
            <ion-avatar slot="start">
              <pos-avatar-control [value]="diner.photo"></pos-avatar-control>
            </ion-avatar>
            <ion-label class="select-resident__resident__information">
              <h2><strong>{{ diner.first_name }} {{ diner.last_name }}</strong></h2>
              <span><strong>ID</strong> {{ diner.client_id }}</span>
              <span *ngIf="diner.type === 'resident'; else dinerInformation"><strong>Live Location</strong>
                {{ diner.live_location }}</span>
              <ng-template #dinerInformation>
                <span><strong>Category</strong> {{ diner.diner_category_name }}</span>
              </ng-template>
            </ion-label>
            <ion-button mode="md"
                        color="dark"
                        debounce-click
                        [debounceTime]="0"
                        (debounceClick)="onResidentSelected(diner)">USE
            </ion-button>
          </ion-item>
        </ng-container>
        <ion-item *ngIf="searchQuery?.length > 2 && !diners?.length"
                  lines="none">
          <p>No diners match the search criteria.</p>
        </ion-item>
      </ion-list>
      <ion-list *ngIf="isSearchingDiner"
                class="table-list__items">
        <pos-diner-assignment-skeleton></pos-diner-assignment-skeleton>
      </ion-list>
    </div>
  </ion-content>
  <ion-footer>
  </ion-footer>
</ng-container>